// extracted by mini-css-extract-plugin
module.exports = {"root":"EmbedPreview_root__3Ounm","title":"EmbedPreview_title__YZ16E","iframe":"EmbedPreview_iframe__2vpqa","disableMouseEvents":"EmbedPreview_disableMouseEvents__CumjD"};